module.exports = __webpack_public_path__ + "img/ic-info.4d6560b8.svg";